import React from 'react';
import { PapiUser } from '@wix/da-types-papi';
import { withTranslation, WithTranslation } from 'react-i18next';
import { WatchedDeviants, Props as WidgetProps } from './WatchedDeviants';
import WidgetBoxWide, {
  Props as WidgetBoxWideProps,
} from '../_partials/WidgetBoxWide';
import getStatLine from '../../../utils/getStatLine';
import EmptyState from '../../EmptyState';
import { URLS } from '@wix/da-url';
import WatchedDeviantsConfigPopover from './WatchedDeviantsConfigPopover';

import s from './WatchedDeviants.scss';

class WatchedDeviantsBoxWide extends React.Component<
  WidgetProps &
    WidgetBoxWideProps &
    WithTranslation & {
      type: 'watchers' | 'watching';
      totalCount?: number;
      isOwner: boolean;
      profileOwnerUser: PapiUser;
    }
> {
  render() {
    const {
      id,
      type,
      subHeader,
      headerExtraElementsOnMobile,
      isHeaderStickyOnMobile,
      totalCount,
      hasMore,
      fetchMore,
      isFetching,
      isEmpty,
      isOwner,
      widgetMenuRenderer,
      widgetMoveUp,
      widgetMoveDown,
      parentRef,
      widgetRemove,
      widgetBoxClassName,
      section,
      zone,
      ...props
    } = this.props;

    return (
      <WidgetBoxWide
        section={section}
        zone={zone}
        moduleId={props.moduleId}
        id={id}
        header={props.t!(`widgets.${type}.header`)}
        count={totalCount}
        subHeader={getStatLine(props.t!, type, totalCount)}
        headerExtraElementsOnMobile={headerExtraElementsOnMobile}
        isHeaderStickyOnMobile={isHeaderStickyOnMobile}
        hasMore={hasMore}
        fetchMore={fetchMore}
        isFetching={isFetching}
        parentRef={parentRef}
        widgetMenuRenderer={close => (
          <WatchedDeviantsConfigPopover
            withManageLink={type === 'watching'}
            moduleId={props.moduleId}
            onClose={close}
          />
        )}
        widgetMoveUp={widgetMoveUp}
        widgetMoveDown={widgetMoveDown}
        widgetRemove={widgetRemove}
        className={widgetBoxClassName}
        isEmpty={isEmpty}
        emptyView={
          isOwner ? (
            <EmptyState
              view="small"
              className={s['empty-state']}
              title={props.t!(`widgets.${type}.empty.title.owner`)}
              subtitle={props.t!(`widgets.${type}.empty.subtitle.owner`)}
              buttonLabel={props.t!(`widgets.${type}.empty.CTALabel.owner`)}
              withButton={true}
              onButtonClick={this.navigateToBrowse}
            />
          ) : (
            <EmptyState
              view="small"
              className={s['empty-state']}
              title={props.t!(`widgets.${type}.empty.title.visitor`, {
                username: props.profileOwnerUser.username,
              })}
              subtitle={props.t!(`widgets.${type}.empty.subtitle.visitor`, {
                username: props.profileOwnerUser.username,
              })}
            />
          )
        }
      >
        <WatchedDeviants {...props} />
      </WidgetBoxWide>
    );
  }

  navigateToBrowse() {
    window.location.replace(URLS.ROOT);
  }
}
export default withTranslation()(
  WatchedDeviantsBoxWide
) as React.ComponentType<{}>;
